import api from './api';

export const getGates = (params) => api.get('/v1/gates', { params });
export const getGate = (id) => api.get(`/v1/gates/${id}`);
export const createGate = (data) => api.post('/v1/gates', data);
export const updateGate = (id, data) => api.put(`/v1/gates/${id}`, data);
export const deleteGate = (id) => api.delete(`/v1/gates/${id}`);
export const batchDeleteGates = (ids) => api.post('/v1/gates/batch-delete', { ids });
